import {
  createAction,
  UnknownAction,
  combineReducers,
  StateFromReducersMapObject,
} from '@reduxjs/toolkit';

import api from 'service/index';
import app from 'modules/app/reducer';
import auth from 'modules/auth/reducer';
import chat from 'modules/chat/reducer';
import forms from 'modules/form/reducer';
import gates from 'modules/gates/reducer';
import kiosk from 'modules/kiosk/reducers';
import basket from 'modules/basket/reducer';
import socket from 'modules/sockets/reducer';
import dealers from 'modules/dealers/reducer';
import refData from 'modules/refData/reducer';
import healthCheck from 'modules/healthCheck/reducer';
import elapsedTime from 'modules/elapsedTime/reducer';
import selfServices from 'modules/selfServices/reducer';
import translations from 'modules/translations/reducer';
import vehicleCheck from 'modules/vehicleCheck/reducer';
import communication from 'modules/communication/reducer';
import onlinePayment from 'modules/onlinePayment/reducer';
import notifications from 'modules/notifications/reducer';
import restrictedAccess from 'modules/restrictedAccess/reducer';
import router from 'modules/router/reducer';

export const resetApp = createAction('RESET_APP');
export const resetApi = createAction('RESET_API');

const reducer = {
  [api.reducerPath]: api.reducer,
  app: app.reducer,
  auth: auth.reducer,
  basket: basket.reducer,
  communication: communication.reducer,
  dealers: dealers.reducer,
  elapsedTime: elapsedTime.reducer,
  form: forms.reducer,
  gates: gates.reducer,
  healthCheck: healthCheck.reducer,
  kiosk,
  notifications: notifications.reducer,
  onlinePayment: onlinePayment.reducer,
  refData: refData.reducer,
  router: router.reducer,
  selfServices: selfServices.reducer,
  socket: socket.reducer,
  translations: translations.reducer,
  vehicleCheck: vehicleCheck.reducer,
  chat: chat.reducer,
  restrictedAccess: restrictedAccess.reducer,
};

const appReducer = combineReducers(reducer);
const rootReducer = (
  state: ReturnType<typeof appReducer>,
  action: UnknownAction,
) => {
  // Reset entire app state
  if (action.type === resetApp.type) {
    return appReducer(undefined, action);
  }

  // Reset only API state (workaround for RTK 2.9.2+ resetApiState() bug)
  // This avoids the "Illegal invocation" error on AbortController
  if (action.type === resetApi.type && state) {
    return appReducer({
      ...state,
      [api.reducerPath]: undefined,
    }, action);
  }

  return appReducer(state, action);
};

export type RootState = StateFromReducersMapObject<typeof reducer>;
export default rootReducer;
